import React from 'react'

import styled from 'styled-components'

const StyledWrapper = styled.h1`
  font-size: 5em;
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  justify-content: center;
  margin: ${() => `${window.screen.height / 3}px 0`};

  @media screen and (max-width: 992px) {
    font-size: 3em;
  }
`

function NotFound() {
  return <StyledWrapper> Página não encontrada </StyledWrapper>
}

export default NotFound
